module.exports = __webpack_public_path__ + "static/media/logo.203d49d6.png";